module.exports = __webpack_public_path__ + "img/i_white.8d8a084d.svg";